import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useParams } from "react-router-dom";

import "styles/main.css";
import { FormInput } from "components/ui/FormInput";
import { PageWrapper } from "components/ui/PageWrapper";
import { ButtonLoader } from "components/Loader/ButtonLoader";

import { Plus, X } from "lucide-react";
import { GetSingleRoutesMutation } from "rest/allRoutes";
import { ComponentLoader } from "components/Loader/ComponentLoader";
import { ErrorComponent } from "components/Alerts/Error";
import { EditRoutesMutation } from "rest/allRoutes";

export default function EditRoutes() {
  const { id } = useParams();
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
    getValues,
  } = useForm();

  const formData = new FormData();
  formData.append("id", id);
  const singleRoutes = GetSingleRoutesMutation(formData);

  const editRoutes = EditRoutesMutation();

  const [perviewImages, setPreviewImages] = useState("");
  const [defaultImg, setDefaultImg] = useState("");
  const [inputs, setInputs] = useState([
    {
      subMenu: "",
      slug: "",
    },
  ]);

  const handleChange = (e) => {
    const files = e?.target?.files[0];
    if (files) {
      const imageUrl = URL.createObjectURL(files);
      setPreviewImages(imageUrl);
    }
  };

  useEffect(() => {
    const defaultValues = {};

    defaultValues.sortNo = singleRoutes?.data?.data?.sortNo;
    defaultValues.name = singleRoutes?.data?.data?.Name;
    defaultValues.image = singleRoutes?.data?.data?.Icon;
    const defaultInputs =
      singleRoutes?.data?.data?.subMenuArray &&
      singleRoutes?.data?.data?.subMenuArray?.map((elm, i) => ({
        subMenu: elm?.subMenu,
        slug: elm?.slug,
      }));

    setInputs(defaultInputs);
    defaultInputs?.map((elm, i) => {
      defaultValues[`subMenu_${i + 1}`] = elm?.subMenu;
      defaultValues[`slug_${i + 1}`] = elm?.slug;
    });

    setDefaultImg(singleRoutes?.data?.data?.Icon);
    reset(defaultValues);
  }, [singleRoutes?.data?.data]);

  const handleAddInputs = () => {
    setInputs([...inputs, { subMenu: "", slug: "" }]);
  };

  const handleDeleteInput = (index) => {
    // Get current form values before deletion
    const currentValues = getValues();
    
    // Create new array without the deleted item
    const newArray = [...inputs];
    newArray.splice(index, 1);
    
    // Build new form data with properly indexed fields
    const newFormData = {
      sortNo: currentValues.sortNo,
      name: currentValues.name,
      image: currentValues.image,
    };
    
    // Rebuild form fields with correct indexing after deletion
    newArray.forEach((item, newIndex) => {
      // Determine the original index of this item
      const originalIndex = newIndex >= index ? newIndex + 1 : newIndex;
      
      // Get the values from the original positions
      const originalSubMenuKey = `subMenu_${originalIndex + 1}`;
      const originalSlugKey = `slug_${originalIndex + 1}`;
      
      // Set them in the new positions
      const newSubMenuKey = `subMenu_${newIndex + 1}`;
      const newSlugKey = `slug_${newIndex + 1}`;
      
      newFormData[newSubMenuKey] = currentValues[originalSubMenuKey] || '';
      newFormData[newSlugKey] = currentValues[originalSlugKey] || '';
    });
    
    // Update state and form
    setInputs(newArray);
    reset(newFormData);
  };

  const onSubmit = (data) => {
    const formData = new FormData();
    formData.append("id", id);
    formData.append("sortNo", data?.sortNo);
    formData.append("Name", data?.name);
    formData.append("Icon", data?.image[0]);
    inputs.forEach((_, index) => {
      const subMenuKey = `subMenu_${index + 1}`;
      const slugKey = `slug_${index + 1}`;
      formData.append("SubMenuArray[]", data[subMenuKey]);
      formData.append("SubMenuSlug[]", data[slugKey]);
    });
    editRoutes.mutate(formData);
  };

  return (
    <div className="resources_page">
      <PageWrapper slug="all-routes" name="All Routes" />
      {singleRoutes?.isError && (
        <ErrorComponent message="OOPS ! something went wrong please try again later" />
      )}
      {singleRoutes?.isPending ? (
        <ComponentLoader />
      ) : (
        <div className="home_banner_input">
          <form onSubmit={handleSubmit(onSubmit)} className=" mt-4 mb-3">
            <div className="row">
              <div className="mb-3 col-md-6">
                <label htmlFor="sortNo" className="form-label">
                  Sort No
                </label>
                <FormInput
                  type="number"
                  name="sortNo"
                  placeholder="Sort No"
                  {...register("sortNo", { required: true })}
                />
                {errors?.sortNo && (
                  <p className="errorMessage">Field is required</p>
                )}
              </div>
              <div className="mb-3 col-md-6">
                <label htmlFor="name" className="form-label">
                  Name
                </label>
                <FormInput
                  type="text"
                  name="name"
                  placeholder="Name"
                  {...register("name", { required: true })}
                />
                {errors?.name && (
                  <p className="errorMessage">Field is required</p>
                )}
              </div>
              <div className="mb-3 col-md-12">
                <label htmlFor="image" className="form-label">
                  Icon
                </label>
                <FormInput
                  type="file"
                  name="image"
                  placeholder="image"
                  {...register("image", {
                    required: !perviewImages && !defaultImg,
                    onChange: (e) => handleChange(e),
                  })}
                />
                {errors?.image && (
                  <p className="errorMessage">Field is required</p>
                )}
                {perviewImages && (
                  <img
                    src={perviewImages}
                    alt="image Preview"
                    style={{ maxWidth: "300px", marginTop: "10px" }}
                  />
                )}
                {!perviewImages && defaultImg && (
                  <img
                    src={defaultImg}
                    alt="image Preview"
                    style={{ maxWidth: "300px", marginTop: "10px" }}
                  />
                )}
              </div>

              {inputs?.length >= 1 &&
                inputs?.map((_, index) => {
                  return (
                    <div key={index} className="row">
                      <div className="mb-3 col-md-5">
                        <label
                          htmlFor={`subMenu_${index + 1}`}
                          className="form-label"
                        >
                          Sub Menu
                        </label>
                        <FormInput
                          type="text"
                          name={`subMenu_${index + 1}`}
                          placeholder="Sub Menu"
                          {...register(`subMenu_${index + 1}`, {
                            required: true,
                          })}
                        />
                        {errors[`subMenu_${index + 1}`] && (
                          <p className="errorMessage">field is required</p>
                        )}
                      </div>
                      <div className="mb-3 col-md-5">
                        <label
                          htmlFor={`slug_${index + 1}`}
                          className="form-label"
                        >
                          Slug
                        </label>
                        <FormInput
                          type="text"
                          placeholder="slug"
                          name={`slug_${index + 1}`}
                          {...register(`slug_${index + 1}`, {
                            required: true,
                          })}
                        />
                        {errors[`slug_${index + 1}`] && (
                          <p className="errorMessage">field is required</p>
                        )}
                      </div>
                      <div className="col-md-2 d-flex align-items-end">
                        {inputs?.length > 1 ? (
                          <div>
                            <span
                              onClick={() => handleDeleteInput(index)}
                              className="btn btn-danger btn_cross_vv"
                            >
                              <X />
                            </span>
                          </div>
                        ) : null}
                        <div className="add_btn">
                          <span
                            onClick={handleAddInputs}
                            className="btn btn-success btn_cross_vv2"
                          >
                            <Plus />
                          </span>
                        </div>
                      </div>
                    </div>
                  );
                })}
            </div>
            <div className="row">
              <div className="col-6">
                {editRoutes?.isPending ? (
                  <ButtonLoader />
                ) : (
                  <div className="mb-3 col-12">
                    <input
                      type="submit"
                      value="submit"
                      className="input_submit"
                    />
                  </div>
                )}
              </div>
            </div>
          </form>
        </div>
      )}
    </div>
  );
}
